import { BsData } from "../../models/ExchBetSlip";
import SAP_API from "../../services/sap";
import store from "../store";
import { addExchangeBetHandler, clearExchangeBets, setOpenBets } from "./exchBetSlipReducer";


export const addExchangeBet = (data: BsData) => {
  // console.log("clicked",data)
    return async (dispatch: Function) => {
      dispatch(clearExchangeBets({}));
      dispatch(addExchangeBetHandler(data));
    //   dispatch(setOpenSlider(true))
    };
  };


  export const fetchOpenBets = (eventId: string, sportId: string) => {

    return async (dispatch: Function) => {
      let authData : any;
      if (store.getState().userDetails.lobby == "EXCHANGE") {
        authData = store.getState().userDetails.exchData;
      } else {
        authData  = store.getState().userDetails.sbData;
      }
      let data = {
        token: authData?.token,
        operatorId: authData?.operatorId,
        sportId: sportId,
        eventId: eventId,
      };
  
      if (sportId && eventId) {
        try {
          let result = null;
          result = await SAP_API.post(`/core/getopenbets`, data);
          if (result && result?.data.status === "RS_OK") {
            dispatch(setOpenBets(result.data?.openBets));
          }
        } catch (err) {
          dispatch(setOpenBets([]));
        }
      }
    };
  };